export default __webpack_public_path__ + "static/media/05.52d3e30c.svg";